import types from "cms/enums/contentsTypes.enum";
export var stepV2Content = {
    label: "step V2 Content",
    type: types.STEP_V2_CONTENT,
    dynamicChildKey: "detailsElements"
};
